import styled from "styled-components";

// #####################################################

export const StyledModalAuthComponent = styled.div`
	display: flex;
	position: relative;
	flex-direction: column;
	width: calc(100vw - 2rem);
	height: calc(100vh - 2rem);
	overflow-y: auto;
	overflow-x: hidden;
	align-items: center;
	justify-content: center;
`;

// #####################################################
